import { Link, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Plus,
  FolderOpen,
  Tag,
  Settings,
  Eye,
  LogOut
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';

const NAV_ITEMS = [
  { to: '/admin', icon: LayoutDashboard, label: 'Dashboard', key: 'dashboard' },
  { to: '/admin/vehiculos/nuevo', icon: Plus, label: 'Nuevo Vehículo', key: 'nuevo' },
  { to: '/admin/categorias', icon: FolderOpen, label: 'Categorías', key: 'categorias' },
  { to: '/admin/marcas', icon: Tag, label: 'Marcas', key: 'marcas' },
  { to: '/admin/configuracion', icon: Settings, label: 'Configuración', key: 'configuracion' },
  { to: '/', icon: Eye, label: 'Ver Sitio', key: 'ver-sitio' },
];

export const AdminSidebar = ({ active }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <aside className="fixed left-0 top-0 h-full w-64 bg-card border-r border-border hidden lg:block">
      <div className="p-6">
        <Link to="/">
          <img src="/logo.png" alt="Chocados GDL" className="h-10" />
        </Link>
      </div>

      <nav className="px-4 space-y-2">
        {NAV_ITEMS.map(item => {
          const Icon = item.icon;
          const isActive = item.key === active;
          return (
            <Link
              key={item.key}
              to={item.to}
              className={`flex items-center gap-3 px-4 py-3 rounded-sm transition-colors ${
                isActive
                  ? 'bg-primary/10 text-primary font-medium'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              }`}
            >
              <Icon className="w-5 h-5" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-border">
        <Button
          variant="ghost"
          onClick={handleLogout}
          className="w-full justify-start text-muted-foreground hover:text-foreground"
        >
          <LogOut className="w-5 h-5 mr-3" />
          Cerrar Sesión
        </Button>
      </div>
    </aside>
  );
};

export const AdminMobileHeader = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="lg:hidden flex items-center justify-between mb-6">
      <Link to="/">
        <img src="/logo.png" alt="Chocados GDL" className="h-8" />
      </Link>
      <Button variant="ghost" size="icon" onClick={handleLogout}>
        <LogOut className="w-5 h-5" />
      </Button>
    </div>
  );
};
